// extracted by mini-css-extract-plugin
module.exports = {"swiper":"Carousel_swiper__3pkSs","handle":"Carousel_handle__3vm0j"};